import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { z } from 'zod';
import { Fichas } from '@/features/fichas/componentes/Fichas';
import { rotaDeTela } from '@/features/permissoes/guardas';

const busca = z.object({
  busca: z.string().optional().catch(undefined),
  categoriaId: z.uuid().optional().catch(undefined),
  padrao: z.boolean().optional().catch(undefined),
  cursor: z.string().optional().catch(undefined),
  tags: z.string().optional().catch(undefined),
  /** Atalho "Nova ficha" do Início (spec 015). */
  novo: z.boolean().optional().catch(undefined),
});

/** Fichas de treino (spec 008, CA-01). */
export const Route = createFileRoute('/_autenticado/fichas/')({
  ...rotaDeTela('fichas.lista'),
  validateSearch: busca,
  component: Pagina,
});

function Pagina() {
  const { novo, ...filtros } = Route.useSearch();
  const navigate = Route.useNavigate();
  // O atalho do Início abre o formulário e sai da URL (recarregar não abre de novo).
  useEffect(() => {
    if (novo === true) void navigate({ search: filtros, replace: true });
  }, [novo, filtros, navigate]);
  return (
    <Fichas
      abrirNova={novo === true}
      filtros={filtros}
      aoMudarFiltros={(novos) => {
        void navigate({ search: novos, replace: true });
      }}
    />
  );
}
